module.exports = __webpack_public_path__ + "static/media/notifications-activer.d34854b9.png";